<script>
export default {
  props: {
    padding: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<template>
  <div :class="['subheader-actions-wrapper', { 'with-padding': padding }]">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.subheader-actions-wrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4.2rem;

  @include media('xxxl', null) {
    margin-bottom: 4rem;
  }

  &.with-padding {
    padding: 3.2rem 7.6rem 0;
  }

  .input-search {
    margin-bottom: 0;
    width: 50%;
  }

  // stylelint-disable selector-pseudo-element-no-unknown
  ::v-deep {
    .icon-cutlery {
      height: 2.4rem;
      margin-right: 1rem;
      width: 2.4rem;
    }

    .fa-times {
      font-size: 1.7rem;
      margin-right: 1rem;
    }

    .icon-pocket {
      margin-right: 1rem;
    }
  }

  .edit-actions-wrapper {
    display: flex;
    justify-content: space-between;

    .button:first-of-type {
      margin-right: 1rem;
    }
  }
}
</style>
